function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  background-color: rgb(239, 247, 239);\n  margin: 0px 0px 20px 0px;\n  border: 1px solid rgb(191, 222, 210);\n  width: 100%;\n  align-items: center;\n  justify-content: flex-start;\n  color: #6d747b;\n  font-size: 13px;\n  width: 400px;\n  padding: 10px 19px;\n  margin-bottom: 25px;\n  line-height: 16px;\n  button {\n    font-size: 13px;\n  }\n\n  @media ",
        " {\n    width: 100%;\n    justify-content: center;\n    display: inline-block;\n    button {\n      display: inline-block;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background-color: white;\n  border: none;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  line-height: 15px;\n  padding: 0;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  background-color: #fffdeb;\n  border: 1px solid #d8d5ba;\n  text-align: ",
        ";\n  width: 100%;\n  font-size: 12px;\n  padding: 11px 14px 11px 19px;\n  color: #75725b;\n  border-radius: 4px;\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  background-color: #fff0f0;\n  border: 1px solid #d8c1c1;\n  width: 100%;\n  padding: 11px 14px 11px 19px;\n  color: #986c6c;\n  border-radius: 4px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { space, width } from 'styled-system';
import { mediaQueries } from 'shared/styles';
export var NotifyBlock = styled.div(_templateObject(), mediaQueries.largePhone);
export var WhiteNotifyBlock = styled(NotifyBlock)(_templateObject1(), space);
export var YellowNotifyBlock = styled(NotifyBlock)(_templateObject2(), function(param) {
    var align = param.align;
    return align || 'left';
}, space);
export var RedNotifyBlock = styled(NotifyBlock)(_templateObject3(), space, width);
